/* eslint no-process-env: 0 */

import { cloneDeep } from "lodash";

import { DEFAULT_STORAGE_VALUE } from "./constant";
import { ConfigStorage } from "./types";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const SERVER_STORAGE: ConfigStorage = cloneDeep(DEFAULT_STORAGE_VALUE);
